var transition = require('../transition')

module.exports = function (value) {
  var el = this.el
  transition.apply(el, value ? 1 : -1, function () {
    el.style.display = value ? '' : 'none'
  }, this.vm)
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/directives/show.js
 ** module id = 32
 ** module chunks = 0
 **/